module.exports = __webpack_public_path__ + "img/spinner.98db99ce.gif";